import { ELocalizationActions, ILocalizationReducer, LocalizationReducer } from './model';

export const defaultReducerValue: ILocalizationReducer = {
  translationsReady: false,
  translations: {},
};

export const reducer: LocalizationReducer = (prevState, action) => {
  switch (action.actionType) {
    case ELocalizationActions.UPDATE_TRANSLATIONS:
      return {
        translations: action.payload.translations,
        translationsReady: true,
      };
    case ELocalizationActions.LOCALIZATION_STATE_UNREADY:
      return {
        ...prevState,
        translationsReady: false,
      };
    case ELocalizationActions.LOCALIZATION_STATE_READY:
      return {
        ...prevState,
        translationsReady: true,
      };
    default:
      return prevState;
  }
};
